// Note: If in future, you would like to use this but with custom text, we can add an additional
// prop to deal with this, and have 'Loading...' as the default fallback
import PropTypes from 'prop-types';

const TextLoader = ({ className }) => (
  <div className={className || ''}>Loading...</div>
);

TextLoader.propTypes = {
  className: PropTypes.string,
};

export default TextLoader;
